import { stitch } from 'keo';
import Snackbar from 'material-ui/Snackbar';
import PropTypes from 'prop-types';
import r from 'render-dom';

import { removeAlert } from 'components/shared/Alert';

import './index.css';

const propTypes = { alert: PropTypes.object };

const style = {
    bodyStyle: {
        height: 'auto',
        lineHeight: '24px',
        padding: '20px 80px 18px 24px',
        position: 'relative',
    },
    buttonStyle: {
        bottom: 'auto',
        color: '#eee',
        lineHeight: 'inherit',
        margin: 0,
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
    },
};

const render = ({ props }) => {
    const { alert } = props;
    const closeAlert = () => removeAlert(alert);

    if (alert) {
        return (
            r(Snackbar, {
                action: 'ok',
                bodyStyle: style.bodyStyle,
                className: 'alert-snackbar',
                onActionClick: closeAlert,
                ...alert,
                onRequestClose: closeAlert,
                open: true,
            })
        );
    }

    return null;
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/public/Toast/index.js